export const faq = {
  welcome: 'Frequently Asked Questions',
  helpCentre: 'FAQ',
  reachOutToSupport:
    'You can reach out to <green>{{email}}</green> if you encounter an error in My NTUC Health application.'
};
